import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ActivityItem from './ActivityItem';
import LoadingSpinner from '../common/LoadingSpinner';
import { getStudentTimeline } from '../../services/studentService';

const ActivityTimeline = ({ studentId }) => {
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTimeline = async () => {
      if (!studentId) return;
      try {
        setLoading(true);
        const { data } = await getStudentTimeline(studentId);
        setTimeline(data.data?.timeline || []);
      } catch (err) {
        console.error('Failed to fetch timeline:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeline();
  }, [studentId]);

  if (loading) return <LoadingSpinner />;

  if (timeline.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No activity recorded yet
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ px: 1 }}>
        Activity Timeline
      </Typography>

      <Box sx={{ position: 'relative', pl: 2 }}>
        {/* Vertical timeline line */}
        <Box
          sx={{
            position: 'absolute',
            left: 17,
            top: 16,
            bottom: 16,
            width: 2,
            backgroundColor: 'divider',
          }}
        />

        {/* Activity items */}
        {timeline.map((activity, index) => (
          <Box
            key={activity._id || index}
            sx={{
              position: 'relative',
              borderBottom: index < timeline.length - 1 ? '1px solid' : 'none',
              borderColor: 'divider',
            }}
          >
            <ActivityItem activity={activity} />
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default ActivityTimeline;
